var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarTriple = function SvgStarTriple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m5.779 12.7 1.248 2.457h2.126a.582.582 0 0 1 .419 1L7.62 18.074l1.08 2.484a.589.589 0 0 1-.839.736l-2.614-1.47-2.615 1.47a.589.589 0 0 1-.839-.736l1.082-2.484-1.95-1.922a.582.582 0 0 1 .419-1H3.47L4.718 12.7a.6.6 0 0 1 1.061 0m6.75-9.751 1.248 2.457H15.9a.582.582 0 0 1 .419 1L14.37 8.324l1.082 2.484a.589.589 0 0 1-.839.736L12 10.074l-2.615 1.47a.589.589 0 0 1-.839-.736l1.081-2.484L7.675 6.4a.582.582 0 0 1 .419-1h2.126l1.248-2.457a.6.6 0 0 1 1.061.006m5.692 9.751-1.248 2.457h-2.126a.582.582 0 0 0-.419 1l1.952 1.922-1.08 2.479a.589.589 0 0 0 .839.736l2.614-1.47 2.615 1.47a.589.589 0 0 0 .839-.736l-1.082-2.484 1.952-1.922a.582.582 0 0 0-.419-1H20.53L19.282 12.7a.6.6 0 0 0-1.061 0"
  })));
};
export default SvgStarTriple;